var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.976,
    height: 14.641,
    viewBox: "0 0 18.976 19.641",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M19.65,17.879l-4.675-4.86a7.923,7.923,0,1,0-6.062,2.827,7.841,7.841,0,0,0,4.541-1.438l4.71,4.9a1.034,1.034,0,1,0,1.49-1.434ZM8.912,2.069a5.859,5.859,0,1,1-5.861,5.86,5.859,5.859,0,0,1,5.861-5.86Z",
    transform: "translate(-0.985 0.002)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.e5c2ed92.svg";
export { ForwardRef as ReactComponent };